module.exports = {
  isTest: false,
  schema: {
    aboutUs: 'about-us',
    accounts: 'accounts',
    apiTokens: 'api-tokens',
    availableFonts: 'fontNameToFileName',
    booteekTokens: 'booteek-tokens',
    checkoutSettings: 'checkout-settings',
    checkouts: 'checkouts',
    collaborators: 'collaborators',
    collageDownloads: 'collage-downloads',
    collageExportRequest: 'collage-export-request',
    collections: 'collections',
    contactUs: 'contact-messages',
    cropData: 'crop-data',
    customers: 'customers',
    groups: 'groups',
    hostesses: 'hostesses',
    inventory: 'inventory',
    inventoryCounts: 'inventory-counts',
    marketplace: 'marketplace',
    marketplaceCounts: 'marketplace-counts',
    newUser: 'new-users',
    pending: 'pending',
    queue: 'queue',
    sentContactUs: 'sent-contact-messages',
    settings: 'settings',
    shoptheroeTokens: 'shoptheroe-tokens',
    shopTheRoeSizes: 'shopTheRoeSizes',
    stripeCustomers: 'stripe_customers',
    stripeWebhooks: 'stripe_webhooks',
    styleData: 'style-data',
    styles: 'styles',
    syncExternal: 'sync-external',
    templateLibrary: 'templates',
    tourSettings: 'tour-settings',
    tours: 'tours',
    transactions: 'transactions',
    userTemplates: 'user-templates'
  }
}



// WEBPACK FOOTER //
// ./src/environments/production.js